/**
 * Single source of truth for kiosk route paths.
 *
 * Use these constants in `<Route path>`, `navigate(...)`, and `<Navigate to>`
 * instead of hard-coded strings so a route rename only touches one place.
 */

export const ROUTES = {
  root: '/',
  login: '/login',

  // Wristband-session flows (print, balance, top-up, purchase, etc.)
  scan: '/scan',
  balance: '/balance',
  topUp: '/top-up',
  purchase: '/purchase',
  history: '/history',
  error: '/error',
  success: '/success',
  staffAssistance: '/staff-assistance',

  fnb: {
    menu: '/fnb/menu',
    cart: '/fnb/cart',
    orderConfirm: '/fnb/order-confirm',
    orderStatus: '/fnb/order-status',
  },

  info: {
    home: '/info',
    map: '/info/map',
    waitTimes: '/info/wait-times',
    shows: '/info/shows',
    wristband: '/info/wristband',
  },

  photos: {
    gallery: '/photos',
    cart: '/photos/cart',
    payment: '/photos/payment',
    receipt: '/photos/receipt',
  },

  walkUp: {
    identity: '/walk-up',
    tickets: '/walk-up/tickets',
    attractions: '/walk-up/attractions',
    overview: '/walk-up/overview',
    success: '/walk-up/success',
  },

  wristband: {
    scan: '/wristband',
    profile: '/wristband/profile',
    addon: '/wristband/addon',
    addonOverview: '/wristband/addon/overview',
    addonSuccess: '/wristband/addon/success',
    transfer: '/wristband/transfer',
    transferRecipient: '/wristband/transfer/recipient',
    transferConfirm: '/wristband/transfer/confirm',
    transferSuccess: '/wristband/transfer/success',
  },
} as const;

export type Routes = typeof ROUTES;
